import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { getTransactionsTableMeta } from "@hooks/view/useViewTableMeta";
import {
    TransactionAccountColumnContent,
    TransactionAccountColumnContentInner,
} from "../ListItem/TransactionAccountColumnContent";

export const AccountCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, TransactionListItem, any>) => {
        if (!row.original.financialAccount) {
            return null;
        }

        // Use pre-hoisted financial accounts from table meta when available
        // to avoid per-row useQuery subscriptions
        const { financialAccounts } = getTransactionsTableMeta(table);

        if (financialAccounts) {
            return (
                <ViewTableCell>
                    <TransactionAccountColumnContentInner
                        transaction={row.original}
                        financialAccounts={financialAccounts}
                    />
                </ViewTableCell>
            );
        }

        return (
            <ViewTableCell>
                <TransactionAccountColumnContent transaction={row.original} />
            </ViewTableCell>
        );
    },
);
AccountCell.displayName = "AccountCell";
